<template v-slot:activator="{ on }">
<v-btn color="white" elevation="0" @click="logout">
    <v-icon>mdi-logout</v-icon>
    Cerrar Sesión
</v-btn>
</template>

<script>
    export default {
        props: {
            logout: {
                type: Function,
                required: true
            }
        },
    }
</script>
<style>
    /* <template><v-tooltip bottom><template v-slot:activator="{ on }"><v-btn icon @click="logout"
    v-on="on"
    ><v-icon>mdi-logout</v-icon></v-btn></template><span>Cerrar Sesión</span></v-tooltip>
</template> */

</style>
